module.exports = __webpack_public_path__ + "static/img/chejia_car_ei5.7095f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/VehicleInformation/chejia_car_ei5.png
// module id = tMpZ
// module chunks = 19